import "./style.less";

export default function AccordianBasic() {
    return {
        scope: {
            items: "=",
        },
        template: require("./template.html"),

        controller: function ($scope) {
            $scope.oneAtATime = true;

            $scope.toggleObj = function (accItem) {
                accItem.isOpen = accItem.isOpen ? false : true;
            };
        },
    };
}
